var $70319821b8cb9e2d$exports = {};
$70319821b8cb9e2d$exports = {
    "loading": `Indl\xe6ser...`,
    "loadingMore": `Indl\xe6ser flere...`
};


export {$70319821b8cb9e2d$exports as default};
//# sourceMappingURL=da-DK.mjs.map
